import { addIcons } from 'hyarchis-global/icons';
import * as regularIcons from 'icons/regular';
import 'hyarchis-global/styles/antd';

export default () => {
  addIcons('regular', regularIcons);
};
